<template>
	<div>
		<div>Inserisci il tuo cap per visualizzare i punti di ritiro disponibili</div>
		<br>
		<div class="map-layout">

			<div class="list">
				<zip-input
					:currentZip.sync="currentZip"
					@geolocate="geolocate"
					class="zip"
				/>

				<points-list 
					:points="points"
					@onClick="selectPoint"
					:selectedPointId="selectedPointId"
					:currentZip="currentZip"
				/>
			</div>
			
			<div
				class="map"
			>
				<google-maps
					ref="googleMaps"
					:points="points"
					:selectedPointId.sync="selectedPointId"
					@onSelectPoint="scrollToPoint"
					@onViewpointUpdate="onViewpointUpdate"
					:currentZip="currentZip"
				/>
			</div>
		</div>

		<br>

		<div class="form flex">
			<form-input
				param="name"
				:inputAttr="{ autocomplete: 'given-name', type: 'text' }"
			/>

			<form-input
				:inputAttr="{  maxlength: 15, autocomplete: 'tel', type: 'tel' }" 
				param="telephone"
			/>

			<form-input
				v-if="$root.config.vuePhone"
				type="vue-phone"
				param="telephone"
			/>
		</div>
	</div>
</template>
<script type="text/javascript">

import GoogleMaps from './MapGoogle'
import { ShipmentZonesApi } from '../../api/ShipmentZonesApi'
import { DeliveryPoints } from '../../core/DeliveryPoints'

import { subscriptionStore } from '../../store/subscriptionStore'
import { deliveryStore } from '../../store/deliveryStore'
import { orderStore } from "../../store/orderStore"

import { deliveryContainer } from '../../mixins/deliveryContainer'

import FormInput from './FormInput'
import ZipInput from './ZipInput'

import PointsList from './PointsList'
export default {
	data () {
		return {
			myPosition: null,
			subscriptionStore: subscriptionStore.state,
			deliveryStore: deliveryStore.state,
			currentZip: null,

			points: null,
			selectedPointId: null,
		}
	},

	mixins: [
		deliveryContainer
	],

	components: {
		ZipInput,
		GoogleMaps,
		FormInput,
		PointsList
	},

	watch: {
		address () {
			this.fillZipCode()
		},

		selectedPointId () {
			const findPoint = () => {
				return this.points.find(point => point.id === this.selectedPointId)
			}
			if (!findPoint()) return

			var oldCity = this.subscriptionStore.subscriptionParams.city
			var oldZip = this.subscriptionStore.subscriptionParams.zip_code

			subscriptionStore.updateSubscriptionParam({ param: 'city', value: findPoint().address.city.toUpperCase() })

			subscriptionStore.updateSubscriptionParam({ param: 'zip_code', value: findPoint().address.zip_code })
			subscriptionStore.updateSubscriptionParam({ param: 'street', value: findPoint().address.street })

			subscriptionStore.updateSubscriptionParam({ param: 'code', value: findPoint().code })
			subscriptionStore.updateSubscriptionParam({ param: 'point_name', value: findPoint().name })

			subscriptionStore.updateSubscriptionParam({ param: 'message', value: null })

			var newCity = this.subscriptionStore.subscriptionParams.city
			var newZip = this.subscriptionStore.subscriptionParams.zip_code
			if (oldCity !== newCity || oldZip !== newZip) this.onChangeCity()
		},

		currentZip () {
			if (!this.currentZip) {
				this.points = []
			}
		}
	},

	computed: {
		address () {
            return this.delivery
                && this.deliveryStore
                && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id)
                && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id).attributes
        },

        delivery () {
            var sub = this.user && this.user.subscription
            return sub && this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
        },

        user () {
        	return this.$root.user
        }
	},

	methods: {
		onViewpointUpdate (viewpoint) {
			var params = {}
			params.bounds = {
				lat0: viewpoint.lat0,
				lat1: viewpoint.lat1,
				lng0: viewpoint.lng0,
				lng1: viewpoint.lng1
			}

			this.loadPoint(params)
		},
		geolocate () {
			this.$refs.googleMaps.geolocate()

			.then(myPosition => {
				this.myPosition = myPosition
				this.currentZip = null
			})

			.catch({

			})
		},

		selectPoint (point) {
			this.selectedPointId = point.id
			this.$refs.googleMaps.selectMarker(point.id, point)
		},

		loadPoint (vars) {
			if (this.subscriptionStore.delivery_type !== 'fermo-point') return
			// this.points = null
			
			var dm = new ShipmentZonesApi()
			dm.points(vars).then(response => {
				var points = new DeliveryPoints(response)
				this.points = points
			})
		},

		onChangeCity () {
			orderStore.updateOrderParam({ param: 'shipment_zone_id', value: null })
			this.$_deliveryContainer_loadDeliveries()
		},

		scrollToPoint () {
			var target = document.getElementById('point-' + this.selectedPointId)
  			target.parentNode.parentNode.scrollTop = target.offsetTop - 60
		},

		updateSubscriptionParam (vars) {
			subscriptionStore.updateSubscriptionParam(vars)
		},

		fillZipCode () {
			if (this.address) this.currentZip = this.address.zip_code
		}
	},

	mounted () {
		this.fillZipCode()
	}
}
</script>

<style scoped>

.map-layout {
	display: flex;
	border: 1.5px solid #ededed;
	border-radius: 4px;
}

.list,
.map {
	flex-grow: 1;
}

.list {
	height: 442px;
	overflow-y: auto;
	max-width: 300px;
	position: relative;
}

.zip {
	position: sticky;
	top: 0;
}

.map {
	flex-basis: 380px;
	max-width: 380px;
    min-width: 380px;
}

.form {
	flex-wrap: wrap;
	text-align: left;
}

.form label {
	flex-basis: 50%;
}

.form label:nth-child(2n) {
	padding-left: 10px;
}

/**/


@media (max-width: 1024px) {
	.list {
		min-width: 100%;
	}
	.map-layout {
		flex-direction: column;
	}

	.map {
		order: -1;
		flex-basis: 0;
		min-width: 0;
	}
}


@media (max-width: 700px) {
	.form label {
		flex-basis: 100%;
	}

	.form label:nth-child(2n) {
		padding-left: 0px;
	}
}
</style>